<script setup lang="ts">
import { computed, inject } from 'vue';

import { useFeatureFlags } from '@/composables/useFeatureFlags';

const isAdmin = inject('isAdmin', false);
const { flags } = useFeatureFlags();
const canShowForm = computed(() => isAdmin && flags.discountCodeForm);
</script>

<template>
  <div
    id="adminDiscountCodeForm"
    data-test="admin-discount-code-form"
    class="mb-10 p-7"
    v-if="canShowForm"
  >
    <form method="POST" action="/cart/attach-discount-code">
      <label aria-label="CT Discount Code">
        <input
          type="text"
          class="textfield"
          id="code"
          name="code"
          placeholder="CT Discount Code"
          aria-label="CT Discount Code"
        />
      </label>
      <button aria-label="Apply" class="ml-5 button secondary">Apply</button>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.ml-5 {
  margin-left: 5px;
}

.mb-10 {
  margin-bottom: 10px;
}

.p-7 {
  padding: 7px;
}

form {
  text-align: center;

  input {
    outline: none;
  }

  button {
    font-family: $font-family-proxima;
    font-style: normal;
    border-width: 1px;
  }
}
</style>
